// App Configuration — Edit here, reflects everywhere
export const APP_CONFIG = {
  version: '3.1.0',
  appName: 'Lucy Garden',
  tagline: 'Fresh Dairy Supply',
  developer: {
    name: 'Makeward Labs',
    tagline: 'Web, Mobile Apps & SaaS Development',
    portfolio: 'https://makeward.in',
    logo: '/MAKEWARD_logo.png',
  },
  phone: '9939079107',
};
